import {
  createApiFactory,
  createPlugin,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { witboostSearchApiRef, WitboostSearchClient } from './api';

/** @public */
export const searchPlugin = createPlugin({
  id: 'wb-search',
  apis: [
    createApiFactory({
      api: witboostSearchApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new WitboostSearchClient({ discoveryApi, identityApi }),
    }),
  ],
});
